import { useTranslation, TFunction } from 'react-i18next';
import { KizenTypography } from '__app/typography';
import {
  useAutomationsDispatch,
  useAutomationsSelector,
} from 'pages/AutomationEngine/store/react';
import { actions } from 'pages/AutomationEngine/store';
import { VariableCard } from '__pages/AutomationEngine/Engine/Steps/type/variable/VariableCard';
import {
  getExecutionMode,
  getHistoryId,
} from 'pages/AutomationEngine/store/selectors';
import { CardProps } from '../../types';

export const content = ({ t }: { t: TFunction }) => {
  return t('Initialize Variable');
};

export default function VariableIntializionAddCard({
  type,
  ...others
}: CardProps) {
  const { t } = useTranslation();
  const dispatch = useAutomationsDispatch();
  const historyId = useAutomationsSelector(getHistoryId);
  const executionMode = useAutomationsSelector(getExecutionMode);
  const disableFeatures = historyId || executionMode;
  return (
    <VariableCard
      {...others}
      type={type}
      addMenu={false} // never show a menu
      onClick={() =>
        disableFeatures ? null : dispatch(actions.dropVariableDefinition())
      }
      cardComponentType={disableFeatures ? '' : 'anchor'}
    >
      <KizenTypography
        data-qa="add-variable-btn"
        {...(disableFeatures
          ? { as: 'span' }
          : { type: 'anchor', href: '', onClick: (e) => e.preventDefault() })}
      >
        {t('Click to add new variable')}
      </KizenTypography>
    </VariableCard>
  );
}
